import ServiceSchemaError from '@/modules/core/models/errors/ServiceSchemaError'
import ConsoleError from '@/modules/core/models/errors/ConsoleError'
import type { ObjectSchema } from 'joi'

export const validate = (schema: ObjectSchema, data: unknown): void => {
  const { error } = schema.validate(data) // { abortEarly: false }

  if (error instanceof ConsoleError) {
    throw error
  }

  if (error) {
    throw new ServiceSchemaError(error)
  }
}
